import React from 'react';
import cookie from 'react-cookies';
import {
  bindOptions,
  extApis,
  filterFieldsForImage,
  filterFieldsForTitleAndDescription,
  pageDirections,
} from './PageFormUtil';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { dynamicSort } from '../../../common/utils/api_utils';
import { getBuilderConfigURL } from '../../../common/utils/builder-config-url-util';
import CustomSelectGroup from '../../../common/formElements/CustomSelectGroup';

const MoreGeneralSetting = ({
  state,
  isTitleFromCollection,
  collectionId,
  handleChange,
  collections,
  titleTag,
  description,
  isDescriptionFromCollection,
  pageImage,
  extraMetaTag,
  pageDirection,
  isPageImageFromCollection,
  projectId,
  externalApis,
}) => {
  const getFieldsOptions = (value) => {
    let options = [];
    if (value) {
      const selectedCollection = collections.find((e) => e.collectionName === value);
      if (!selectedCollection || selectedCollection === null) return [];

      const fields = selectedCollection ? selectedCollection.fields : [];
      const utilities = selectedCollection ? selectedCollection.utilities : [];
      const filteredFileds = filterFieldsForTitleAndDescription(fields);
      const fieldOptions = filteredFileds.sort(dynamicSort('fieldName')).map((item, key) => {
        return { value: item.fieldName, label: item.fieldTitle.en };
      });

      const utilityOptions = utilities.sort(dynamicSort('name')).map((utility) => {
        return {
          value: utility.name,
          label: utility.name,
        };
      });
      options = [
        {
          label: 'Fields',
          options: fieldOptions,
        },
        {
          label: 'Derived Fields',
          options: utilityOptions,
        },
      ];
    }
    return options;
  };
  const getImageFieldsOptions = (value) => {
    let options = [];
    if (value) {
      const selectedCollection = collections.find((e) => e.collectionName === value);
      if (!selectedCollection || selectedCollection === null) return [];

      const fields = selectedCollection ? selectedCollection.fields : [];
      const filteredFields = filterFieldsForImage(fields);
      options = filteredFields.sort(dynamicSort('fieldName')).map((item, key) => {
        return { value: item.fieldName, label: item.fieldTitle.en };
      });
    }
    return options;
  };

  const getImageOptions = () => {
    const { images } = state;
    const options =
      images.length > 0
        ? images.sort(dynamicSort('fileName')).map((image) => ({
            value: image.key,
            label: (
              <div>
                <img
                  src={`${process.env.REACT_APP_S3_URL}${image.key}`}
                  height="35px"
                  width="45px"
                />

                {image.fileName}
              </div>
            ),
          }))
        : [];
    return options;
  };

  const collectionsOptions = () => {
    let options = [{ value: '', label: 'Select a Collection' }];
    const collectionOptions =
      collections.length > 0
        ? collections.sort(dynamicSort('collectionName')).map((collection) => {
            return { value: collection.collectionName, label: collection.collectionTitle };
          })
        : [];
    return [...options, ...collectionOptions];
  };

  const bindCollectionField = () => {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { collectionId } = state;
    return (
      <div className="form-group">
        <label htmlFor="collectionId">Bind Collection</label>
        <a
          href={`${getBuilderConfigURL()}collections/${projectId}/create?token=${token}`}
          className="direction-custom-link"
        >
          Create Collection
        </a>
        <CustomSelect
          name={'collectionId'}
          isMulti={false}
          onChange={handleChange}
          options={collectionsOptions()}
          value={collectionId}
        />
      </div>
    );
  };

  const bindCollectionDataFrom = () => {
    const { collectionFrom, collectionId } = state;
    if (collectionId) {
      return (
        <div className="form-group">
          <label htmlFor="collectionFrom">Bind Data From</label>
          <CustomSelect
            name={'collectionFrom'}
            isMulti={false}
            onChange={handleChange}
            options={bindOptions}
            value={collectionFrom}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  const getRowLevelSecurityFilterOptions = () => {
    const { collectionId } = state;
    if (!collectionId) return [];
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionId,
    );
    if (!selectedCollection) return [];
    const { rowLevelSecurityFilter } = selectedCollection;
    const rlsOptions =
      rowLevelSecurityFilter && rowLevelSecurityFilter.length
        ? rowLevelSecurityFilter.map((filter) => ({
            value: filter.uuid,
            label: filter.name,
          }))
        : [];
    return rlsOptions;
  };
  const bindRowLevelSecurityFilters = () => {
    const { rlsFilter, collectionId } = state;
    if (collectionId) {
      return (
        <div>
          <div className="form-group">
            <label htmlFor="rlsFilter">Row Level Security Filter</label>
            <CustomSelect
              key={'rlsFilter'}
              name={'rlsFilter'}
              isMulti={false}
              onChange={handleChange}
              options={getRowLevelSecurityFilterOptions()}
              value={rlsFilter}
            />
          </div>
        </div>
      );
    }
  };
  const externalAPIOptions = () => {
    const { collectionId } = state;

    let options = [{ value: '', label: 'Select an External API' }];
    const externalApiOptions =
      externalApis.length > 0
        ? externalApis
            .filter(
              (api) =>
                extApis.includes(api.externalApiType) &&
                api.responseDataMapping.selectedCollectionName === collectionId,
            )
            .sort(dynamicSort('externalApiName'))
            .map((api) => {
              return { value: api.uuid, label: api.externalApiName };
            })
        : [];
    return [...options, ...externalApiOptions];
  };
  const bindExternalAPI = () => {
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const { collectionFrom, collectionId, externalApiId } = state;
    if (collectionId && collectionFrom === 'EXTERNAL_API') {
      return (
        <div className="form-group">
          <label htmlFor="externalApiId">Bind External API</label>
          <a
            href={`${getBuilderConfigURL()}externalapi/${projectId}/create?token=${token}`}
            className="direction-custom-link"
          >
            Create External API
          </a>
          <CustomSelect
            name="externalApiId"
            isMulti={false}
            onChange={handleChange}
            options={externalAPIOptions()}
            value={externalApiId}
          />
        </div>
      );
    } else {
      return '';
    }
  };
  return (
    <div className="row">
      <div className="col-12">
        {bindCollectionField()}
        {bindCollectionDataFrom()}
        {bindRowLevelSecurityFilters()}
        {bindExternalAPI()}
        <div className="form-group">
          <label htmlFor="titleTag">Page Title</label>
          {isTitleFromCollection && collectionId !== '' ? (
            <CustomSelectGroup
              name={'titleTag'}
              isMulti={false}
              placeholder="Select an option"
              onChange={handleChange}
              options={getFieldsOptions(collectionId)}
              value={titleTag}
            />
          ) : (
            <input
              type="text"
              name="titleTag"
              className="form-control form-control-sm"
              placeholder="Title"
              value={titleTag}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
          )}
          {collectionId !== '' && (
            <>
              <input
                type="checkbox"
                name="isTitleFromCollection"
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={isTitleFromCollection}
              />
              <label htmlFor="isTitleFromCollection">
                &nbsp;Select from bound Collection Fields
              </label>
            </>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">Page Description</label>
          {isDescriptionFromCollection && collectionId !== '' ? (
            <CustomSelectGroup
              name="description"
              isMulti={false}
              placeholder="Select an option"
              onChange={handleChange}
              options={getFieldsOptions(collectionId)}
              value={description}
            />
          ) : (
            <input
              type="text"
              name="description"
              className="form-control form-control-sm"
              placeholder="Description"
              value={description}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
          )}
          {collectionId !== '' && (
            <>
              <input
                type="checkbox"
                name="isDescriptionFromCollection"
                checked={isDescriptionFromCollection}
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
              />
              <label htmlFor="isDescriptionFromCollection">
                &nbsp;Select from bound Collection Fields
              </label>
            </>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="pageImage">Image</label>
          <CustomSelect
            name="pageImage"
            isMulti={false}
            placeholder="Select an option"
            onChange={handleChange}
            options={
              isPageImageFromCollection && collectionId !== ''
                ? getImageFieldsOptions(collectionId)
                : getImageOptions()
            }
            value={pageImage}
          />
          {collectionId !== '' && (
            <>
              <input
                type="checkbox"
                name="isPageImageFromCollection"
                checked={isPageImageFromCollection}
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
              />
              <label htmlFor="isPageImageFromCollection">
                &nbsp;Select from bound Collection Fields
              </label>
            </>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="extraMetaTag">Page Meta</label>
          <textarea
            type="text"
            name="extraMetaTag"
            className="form-control"
            autoComplete="off"
            rows="2"
            value={extraMetaTag}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="pageDirection">Page Direction</label>
          <small>( Update page layout direction: ltr (Default) or, rtl )</small>
          <CustomSelect
            name={'pageDirection'}
            isMulti={false}
            onChange={handleChange}
            options={pageDirections}
            value={pageDirection}
          />
        </div>
      </div>
    </div>
  );
};

export default MoreGeneralSetting;
